/** Bar chart of binned values, used on the exploration results page. */
import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip } from 'recharts';
import Box from '@mui/material/Box';
import { Colors } from "../styles/Colors";

const defaultMargin = { top: 12, right: 20, left: 12, bottom: 52 };

const BinBarChart = ({ data, width = 520, height = 380, margin = defaultMargin }) => {
  // Function to calculate bins and counts
  const calculateBins = (widths) => {
    if (!widths || widths.length === 0) {
      return [];
    }
    const binSize = 8; // Number of bins
    const max = Math.max(...widths);
    const min = Math.min(...widths);
    if (max === min) {
      return [{ range: String(min), count: widths.length }];
    }
    const binWidth = (max - min) / binSize;

    // Initialize bins
    const bins = Array.from({ length: binSize }, (_, index) => ({
      range: `${(min + index * binWidth).toFixed(2)}-${(min + (index + 1) * binWidth).toFixed(2)}`,
      count: 0,
    }));

    // Calculate counts in bins
    widths.forEach((width) => {
      const binIndex = Math.floor((width - min) / binWidth);
      if (binIndex >= 0 && binIndex < binSize) {
        bins[binIndex].count += 1;
      }
    });

    return bins;
  };

  const binsData = calculateBins(data);

  return (
    <Box sx={{ width, maxWidth: "100%", flexShrink: 0, mx: "auto" }}>
      <BarChart width={width} height={height} data={binsData} margin={margin}>
        <XAxis
          dataKey="range"
          tick={{ fontSize: 10 }}
          stroke="#94a3b8"
          interval={0}
          angle={-35}
          textAnchor="end"
          height={56}
          label={{
            value: "Width range",
            angle: 0,
            position: "insideBottom",
            offset: -8,
            fill: "#64748b",
            fontSize: 12,
          }}
        />
        <YAxis tick={{ fontSize: 11 }} stroke="#94a3b8" />
        <Tooltip contentStyle={{ borderRadius: 8, border: "1px solid #e2e8f0" }} />
        <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" />
        <Bar
          dataKey="count"
          name="Clusters"
          fill={Colors.blue}
          radius={[4, 4, 0, 0]}
          background={{ fill: "transparent" }}
        />
      </BarChart>
    </Box>
  );
};

export default BinBarChart;